/**
 * 모델
 * @window w_popup_e411_cri
 * @category 팝업
 */
import { computed } from 'mobx';

export class PopupModel {
  /**
   * 회사코드
   *
   * **data type** varchar(8)
   */
  readonly custcd: string;

  /**
   * 사업장코드
   *
   * **data type** varchar(2)
   */
  readonly spjangcd: string;

  /**
   * 거래처명
   *
   * **data type** varchar(13)
   */
  cltcd: string;

  /**
   * 현장코드
   *
   * **data type** varchar(15)
   */
  actcd: string;

  /**
   * 현장명
   *
   * **data type** varchar(100)
   */
  actnm: string;

  /**
   * 전분류
   *
   * **data type** varchar(2)
   */
  contg: string;

  /**
   * 인사코드
   *
   * **data type** varchar(10)
   */
  perid: string;

  /**
   * 대수
   *
   * **data type** float
   */
  qty: string;

  /**
   * 전화번호
   *
   * **data type** varchar(20)
   */
  tel: string;

  /**
   * 팩스
   *
   * **data type** varchar(20)
   */
  fax: string;

  /**
   * 분류
   *
   * **data type** char(1)
   */
  flag: string;

  /**
   * 분류
   *
   * **data type** char(1)
   */
  kcresultnm: string;

  /**
   * 홈페이지
   *
   * **data type** varchar(50)
   */
  homepage: string;

  /**
   * 주소
   *
   * **data type** varchar(6)
   */
  zipcode: string;

  /**
   * 주소2
   *
   * **data type** varchar(100)
   */
  address: string;

  /**
   * 상세주소
   *
   * **data type** varchar(100)
   */
  address2: string;

  /**
   * 시작일
   *
   * **data type** varchar(8)
   */
  stdate: string;

  /**
   * 종료일
   *
   * **data type** varchar(8)
   */
  enddate: string;

  /**
   * 금액
   *
   * **data type** float
   */
  samt: string;

  /**
   * 보수료
   *
   * **data type** float
   */
  amt: string;

  /**
   * 대당금액
   *
   * **data type** varchar(?)
   */
  monamt: string;

  /**
   * 비고
   *
   * **data type** varchar(255)
   */
  remark: string;

  /**
   * 입력자
   *
   * **data type** varchar(10)
   */
  inperid: string;

  /**
   * 입력일
   *
   * **data type** varchar(8)
   */
  indate: string;

  /**
   * 해지사유
   *
   * **data type** varchar(100)
   */
  clsnm: string;

  /**
   * 해지상세사유
   *
   * **data type** varchar(100)
   */
  clsremark: string;

  /**
   * 비고
   *
   * **data type** text
   */
  bigo: string;

  /**
   * 구분
   *
   * **data type** varchar(3)
   */
  gubun: string;

  /**
   * 계약구분
   *
   * **data type** varchar(10)
   */
  contgubun: string;

  /**
   * 순서
   *
   * **data type** varchar(3)
   */
  seq: string;

  /**
   * 전분류
   *
   * **data type** varchar(5)
   */
  becontg: string;

  /**
   * 해지일
   *
   * **data type** varchar(8)
   */
  clsrecedate: string;

  /**
   * 처리
   *
   * **data type** varchar(1)
   */
  compflag: string;

  /**
   * 부서명
   *
   * **data type** varchar(40)
   */
  divinm: string;

  /**
   * 담당자
   *
   * **data type** varchar(30)
   */
  pernm: number;

  /**
   * 현장담당자
   *
   * **data type** varchar(30)
   */
  actpernm: number;

  /**
   * 계약자
   *
   * **data type** varchar(30)
   */
  contpernm: number;

  /**
   * 담당전화번호
   *
   * **data type** varchar(30)
   */
  hp: number;

  /**
   * 유무상
   *
   * **data type** varchar(?)
   */
  mgunun: string;

  /**
   * 설치->보수일
   *
   * **data type** varchar(?)
   */
  senddate: string;

  /**
   * 호기명
   *
   * **data type** varchar(?)
   */
  equpnm: string;

  /**
   * 접수자
   *
   * **data type** varchar(?)
   */
  repernm: string;

  /**
   * 접수일자
   *
   * **data type** varchar(?)
   */
  recedate: string;

  /**
   * 접수시간
   *
   * **data type** varchar(?)
   */
  recetime: string;

  /**
   * 완료일자
   *
   * **data type** varchar(?)
   */
  compdate: string;

  /**
   * 완료시간
   *
   * **data type** varchar(?)
   */
  comptime: string;

  /**
   * 도착일자
   *
   * **data type** varchar(?)
   */
  arrivdate: string;

  /**
   * 도착시간
   *
   * **data type** varchar(?)
   */
  arrivtime: string;

  /**
   * 대수
   *
   * **data type** varchar(?)
   */
  cnt: string;

  /**
   * 건수
   *
   * **data type** varchar(?)
   */
  ascnt: string;

  /**
   * 고장내용
   *
   * **data type** varchar(?)
   */
  contnm: string;

  /**
   * 고장내용상세
   *
   * **data type** varchar(?)
   */
  contremark: string;

  /**
   * 처리내용
   *
   * **data type** varchar(?)
   */
  resunm: string;

  /**
   * 처리내용상세
   *
   * **data type** varchar(?)
   */
  resuremark: string;

  /**
   * 고장요인
   *
   * **data type** varchar(?)
   */
  remonm: string;

  /**
   * 고장요인상세
   *
   * **data type** varchar(?)
   */
  remoremark: string;

  /**
   * 고장원인
   *
   * **data type** varchar(?)
   */
  facnm: string;

  /**
   * 고장부위
   *
   * **data type** varchar(?)
   */
  greginm: string;

  /**
   * 고장부위상세
   *
   * **data type** varchar(?)
   */
  reginm: string;

  /**
   * 처리방법
   *
   * **data type** varchar(?)
   */
  resultnm: string;

  /**
   * 대응시간
   *
   * **data type** varchar(?)
   */
  resutime: number;

  /**
   * 처리시간
   *
   * **data type** varchar(?)
   */
  resulttime: number;

  /**
   * 고장부위
   *
   * **data type** varchar(?)
   */
  greqinm: string;

  /**
   * 진행내역
   *
   * **data type** varchar(?)
   */
  result: string;

  /**
   * 담당부서명
   *
   * **data type** varchar(?)
   */
  actdivinm: string;

  /**
   * 하단 총계 데이터
   *
   * **data type** varchar(?)
   */
  cnt_tot: string;

  /**
   * 하단 총계 데이터
   *
   * **data type** varchar(?)
   */
  equp_cnttot: string;

  /**
   * 하단 총계 데이터
   *
   * **data type** varchar(?)
   */
  receperid: string;

  /**
   * 하단 총계 데이터
   *
   * **data type** varchar(?)
   */
  equpcd: string;

  /**
   * 하단 총계 데이터
   *
   * **data type** varchar(?)
   */
  perid2: string;

  /**
   * 하단 총계 데이터
   *
   * **data type** varchar(?)
   */
  recenum: string;

  /**
   * 하단 총계 데이터
   *
   * **data type** varchar(?)
   */
  compnum: string;

  /**
   * 하단 총계 데이터
   *
   * **data type** varchar(?)
   */
  contcd: string;

  /**
   * 하단 총계 데이터
   *
   * **data type** varchar(?)
   */
  contents: string;

  /**
   * 하단 총계 데이터
   *
   * **data type** varchar(?)
   */
  gregicd: string;

  /**
   * 하단 총계 데이터
   *
   * **data type** varchar(?)
   */
  regicd: string;

  /**
   *
   *
   * **data type** varchar(?)
   */
  remocd: string;

  /**
   *
   *
   * **data type** varchar(?)
   */
  resucd: string;

  /**
   *
   *
   * **data type** varchar(?)
   */
  resutottime: string;

  /**
   *
   *
   * **data type** varchar(?)
   */
  resultcd: string;

  /**
   *
   *
   * **data type** varchar(?)
   */
  customer: string;

  /**
   *
   *
   * **data type** varchar(?)
   */
  faccd: string;

  /**
   *
   *
   * **data type** varchar(?)
   */
  divicd: string;

  /**
   *
   *
   * **data type** varchar(?)
   */
  divicd2: string;

  /**
   * ?
   *
   * **data type** varchar(?)
   */
  wad: string;

  /**
   * 신규인지
   *
   * **data type** varchar(1)
   */
  new: string;

  /**
   * 체크유무
   *
   * **data type** varchar(1)
   */
  chk: string;

  constructor(data: any = {}, isNew: boolean = false) {
    this.custcd = data.custcd || '';
    this.spjangcd = data.spjangcd || '';
    this.cltcd = data.cltcd || '';
    this.actcd = data.actcd || '';
    this.actnm = data.actnm || '';
    this.equpnm = data.equpnm || '';
    this.contg = data.contg || '';
    this.perid = data.perid || '';
    this.qty = data.qty || '';
    this.tel = data.tel || '';
    this.fax = data.fax || '';
    this.flag = data.flag || '';
    this.homepage = data.homepage || '';
    this.zipcode = data.zipcode || '';
    this.address = data.address || '';
    this.address2 = data.address2 || '';
    this.stdate = data.stdate || '';
    this.enddate = data.enddate || '';
    this.samt = data.samt || '';
    this.amt = data.amt || '';
    this.monamt = data.monamt || '';
    this.remark = data.remark || '';
    this.inperid = data.inperid || '';
    this.indate = data.indate || '';
    this.clsnm = data.clsnm || '';
    this.clsremark = data.clsremark || '';
    this.bigo = data.bigo || '';
    this.gubun = data.gubun || '';
    this.contgubun = data.contgubun || '';
    this.seq = data.seq || '';
    this.becontg = data.becontg || '';
    this.clsrecedate = data.clsrecedate || '';
    this.compflag = data.compflag || '';
    this.divinm = data.divinm || '';
    this.pernm = data.pernm || '';
    this.actpernm = data.actpernm || '';
    this.contpernm = data.contpernm || '';
    this.mgunun = data.mgunun || '';
    this.greqinm = data.greqinm || '';
    this.resutottime = data.resutottime || '';
    this.hp = data.hp || '';
    this.senddate = data.senddate || '';
    this.repernm = data.repernm || '';
    this.recedate = data.recedate || '';
    this.recetime = data.recetime || '';
    this.compdate = data.compdate || '';
    this.comptime = data.comptime || '';
    this.arrivdate = data.arrivdate || '';
    this.arrivtime = data.arrivtime || '';
    this.cnt = data.cnt || '';
    this.ascnt = data.ascnt || '';
    this.contnm = data.contnm || '';
    this.contremark = data.contremark || '';
    this.resunm = data.resunm || '';
    this.resuremark = data.resuremark || '';
    this.remonm = data.remonm || '';
    this.remoremark = data.remoremark || '';
    this.facnm = data.facnm || '';
    this.greginm = data.greginm || '';
    this.reginm = data.reginm || '';
    this.resultnm = data.resultnm || '';
    this.resutime = data.resutime || '';
    this.resulttime = data.resulttime || '';
    this.result = data.result || '';
    this.actdivinm = data.actdivinm || '';
    this.cnt_tot = data.cnt_tot || '';
    this.receperid = data.receperid || '';
    this.equpcd = data.equpcd || '';
    this.perid2 = data.perid2 || '';
    this.recenum = data.recenum || '';
    this.compnum = data.compnum || '';
    this.contcd = data.contcd || '';
    this.contents = data.contents || '';
    this.kcresultnm = data.kcresultnm || '';
    this.gregicd = data.gregicd || '';
    this.regicd = data.regicd || '';
    this.remocd = data.remocd || '';
    this.resucd = data.resucd || '';
    this.resultcd = data.resultcd || '';
    this.customer = data.customer || '';
    this.faccd = data.faccd || '';
    this.divicd = data.divicd || '';
    this.divicd2 = data.divicd2 || '';
    this.wad = data.wad || '';
    this.equp_cnttot = data.equp_cnttot || '';
    this.chk = data.chk || '0';
    this.new = isNew ? '1' : '0';
  }

  @computed
  get isNew() {
    return this.new === '1';
  }

  @computed
  get isChecked() {
    return this.chk === '1';
  }
}
